/* eslint-disable @typescript-eslint/no-unused-vars */
import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from '@chakra-ui/accordion'
import { Box, Flex, Text } from '@chakra-ui/layout'
import { useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaChevronDown, FaChevronRight, FaEye, FaFileDownload, FaFileUpload, FaPencilAlt, FaPlus, FaTrash } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { ModalDelete } from '../../../components/ModalDelete'
import { NavLine } from '../../../components/NavLine'
import { SearchCmp } from '../../../components/SearchCmp'
import { SelectCmp } from '../../../components/SelectCmp'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { CriterioResponse } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { Body } from '../../Layouts/Body'
import { Sidebar } from '../Gestao/components/Sidebar'
import { CriterioBarChart } from './components/BarChart'
import { ModalCadastroEmMassa } from './components/ModalCadastroEmMassa'
import { CriterioInput, ModalCriterioCreate } from './components/ModalCreate'

export const Criterios: React.FC = () => {
  const nav = useNavigate()
  const tipoOptions = [
    { label: 'Selecione um tipo', value: -1 },
    { label: 'Organizacional', value: 0 },
    { label: 'Liderança', value: 1 },
    { label: 'Técnica', value: 2 }
  ]
  const [Texto, setTexto] = useState('')
  const [Tipo, setTipo] = useState('-1')
  const [ModalIsOpen, setModalIsOpen] = useState(false)
  const [Criterios, setCriterios] = useState<CriterioResponse[]>([])
  const [ModelEdit, setModelEdit] = useState<CriterioResponse>()
  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingGraph, setIsLoadingGraph] = useState(false)
  const [DeleteId, setDeleteId] = useState<string>()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const toast = useToast()
  const [ModalCadastroIsOpen, setModalCadastroIsOpen] = useState(false)
  const TipoCriterio = ['Organizacional', 'Liderança', 'Técnica']

  function onDeleteCriterio(criterioId: string): void {
    setIsLoading(true)

    appApi.delete(`api/Criterios/${criterioId}`)
      .then((res) => {
        toast({
          title: 'Critério excluído com sucesso',
          position: 'top',
          duration: 4000,
          status: 'success'
        })
        GetCriterios()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
        setDeleteId(undefined)
      })
  }

  function PostCriterio(newCriterio: CriterioInput): void {
    setIsLoading(true)
    setIsLoadingGraph(true)

    appApi.post('api/Criterios', newCriterio)
      .then((res) => {
        toast({
          title: 'Criterio criado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        GetCriterios()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
        setModelEdit(undefined)
        setIsLoadingGraph(false)
        setModalIsOpen(false)
      })
  }

  function PutCriterio(newCriterio: CriterioInput): void {
    appApi.put(`api/Criterios/${ModelEdit?.id}`, newCriterio)
      .then((res) => {
        toast({
          title: 'Criterio atualizado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        setModelEdit(undefined)
        setModalIsOpen(false)
        setIsLoadingGraph(true)
        GetCriterios()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
      })
  }

  function GetCriterios(): void {
    setIsLoading(true)

    appApi.get('api/Criterios')
      .then((res) => {
        setCriterios(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (IsLoadingGraph) {
      setTimeout(() => {
        setIsLoadingGraph(false)
      }, 300)
    }
  }, [IsLoadingGraph])

  useEffect(() => {
    GetCriterios()
  }, [])

  return (
    <Flex justifyContent={'center'} alignItems={'self-start'} pos={'relative'} gap={'2rem'} margin={'0 auto'} pr={'2rem'}>
      {<ModalCriterioCreate
        isOpen={ModalIsOpen}
        onClose={() => { setModalIsOpen(false); setModelEdit(undefined) }}
        onCreate={(input, update) => update ? PutCriterio(input) : PostCriterio(input)}
        modelEdit={ModelEdit}
      />}
      <ModalCadastroEmMassa
        isOpen={ModalCadastroIsOpen}
        onRequestClose={() => setModalCadastroIsOpen(false)}
        reload={() => { GetCriterios() }}
      />
      {DeleteId && <ModalDelete
        isOpen
        message='Todos os cargos que estiverem associados à algum nível desse critério serão desvinculados dele, tem certeza que deseja prosseguir com a exclusão desse critério?'
        onConfirm={() => onDeleteCriterio(DeleteId)}
        onRequestClose={() => setDeleteId(undefined)}
        center
      />}
      <Flex
        position="sticky"
        top="0"
        left="0"
        direction="column"
        bg="white"
        transition="width 0.3s"
        width={isCollapsed ? '60px' : '220px'}
        height="100vh">
        <Sidebar isCollapsed={isCollapsed} onCollapse={setIsCollapsed} selecionado={'Critérios'}/>
      </Flex>
      <Body isLoading={IsLoading} style={{ width: '100%' }} width={'100%'}>
        <Flex flexDir={'column'} gap={'1rem'}>
          <Flex justifyContent={'space-between'}>
            <NavLine
              options={[
                {
                  nome: 'Cargos',
                  path: '/Descritivo/Cargos'
                },
                { nome: 'Criterios' }
              ]}
            />
            <Flex gap={'.75rem'} justifyContent={'end'}>
              <ButtonCmp VarColor='c6' onClick={() => nav(-1)}>Voltar</ButtonCmp>
              <ButtonCmp OutlineColor='Rosa' leftIcon={<FaFileUpload/>} onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/Criterios/CSV?token=${localStorage.getItem('token')}` }}>Exportar dados</ButtonCmp>
              <ButtonCmp OutlineColor='Rosa' leftIcon={<FaFileDownload/>} onClick={() => setModalCadastroIsOpen(true)}>Importar dados</ButtonCmp>
              <ButtonCmp VarColor='Green2' leftIcon={<FaPlus/>} onClick={() => setModalIsOpen(true)}>Criar novo criterio</ButtonCmp>
            </Flex>
          </Flex>
          <Flex justifyContent={'space-between'} mt={'1rem'} alignItems={'end'}>
            <h1>Gerenciamento de Critérios</h1>
            <Flex gap={'.75rem'} alignItems={'end'} w={'32rem'}>
              <SelectCmp
                w="100%"
                title="Tipo de critério"
                placeholder="Selecione o tipo..."
                value={Tipo}
                OnChange={setTipo}
              >
                {tipoOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </SelectCmp>
              <SearchCmp
                EnterAction={() => {}}
                OnChange={setTexto}
                placeholder={'Nome do criterio ou tag...'}
                width={'100%'}
              />
            </Flex>
          </Flex>
        </Flex>
        <LoadingContainer loading={IsLoading} linhas={28}>
          <Flex flexDir={'column'} gap={'1rem'} my={'1rem'}>
            {Criterios.filter((criterio) => {
              if (Texto !== '' && !criterio.nomeCriterio.toLowerCase().includes(Texto.toLowerCase())) return null
              if (Tipo !== '-1' && criterio.tipo.toString() !== Tipo) return null
              return criterio
            }).map(criterio => {
              return (
                <WhiteContainer key={criterio.id}>
                  <Accordion allowToggle>
                    <AccordionItem border="none">
                      {({ isExpanded }) => (
                        <>
                          <Flex
                            borderBottom={isExpanded ? '1px solid var(--Azul)' : 'none'}
                            pb={isExpanded ? '1rem' : 'none'}
                            mb={isExpanded ? '1rem' : 'none'}
                            _hover={{ bg: 'gray.50' }}
                            transition=".3s"
                          >
                            <AccordionButton bg="white" _focus={{ boxShadow: 'none !important' }} onClick={() => { if (!isExpanded) { setIsLoadingGraph(true) } }}>
                              <Flex flex="1" direction="column" gap=".25rem" alignItems="self-start">
                                <Flex gap=".5rem" alignItems="center">
                                  <Box
                                    as={isExpanded ? FaChevronDown : FaChevronRight}
                                    color="var(--Green2)"
                                    size="20px"
                                    transition="transform 0.2s ease"
                                  />
                                  <Text color="#000" fontSize="22px" fontWeight="bold">
                                    {criterio.nomeCriterio}
                                  </Text>
                                </Flex>
                                {criterio.descricao && <Text fontSize="14px" color="var(--Gray3)" textAlign={'justify'} maxW={'92%'}>
                                  Descrição: {criterio.descricao}
                                </Text>}
                                <Text fontSize="14px" color="var(--Gray3)">
                                  Tipo: {TipoCriterio[criterio.tipo]}
                                </Text>
                                <Text fontSize="14px" color="var(--Rosa)" fontWeight="medium">
                                  {criterio.niveis.length} Níveis Cadastrados
                                </Text>
                              </Flex>
                            </AccordionButton>

                            <Flex flexDir="column" gap=".5rem">
                              <ElementoTooltipCmp label="Editar" bg="var(--Rosa)">
                                <ButtonCmp OutlineColor="Rosa" onClick={() => { setModelEdit(criterio); setModalIsOpen(true) }}>
                                  <FaPencilAlt />
                                </ButtonCmp>
                              </ElementoTooltipCmp>
                              <ElementoTooltipCmp label="Excluir" bg="var(--Red)">
                                <ButtonCmp OutlineColor="Red" onClick={() => setDeleteId(criterio.id)}>
                                  <FaTrash />
                                </ButtonCmp>
                              </ElementoTooltipCmp>
                            </Flex>
                          </Flex>

                          <AccordionPanel
                            border="2px solid var(--c6)"
                            bg="var(--c2)"
                            display="flex"
                            flexDirection="column"
                            alignItems={'center'}
                            gap="1rem"
                          >
                            {criterio.niveisMinimos && criterio.niveisMinimos.length > 0 && <Flex flexDir="column" gap=".5rem">
                              <Flex px={'2rem'} justifyContent={'space-around'}>
                                <Text fontSize="16px" fontWeight="bold">Níveis</Text>
                                <Text fontSize="16px" fontWeight="bold">Quantidades de funções (mínimas) atribuídas para cada nível do cargo</Text>
                              </Flex>
                              <CriterioBarChart data={criterio.niveisMinimos} id={`${criterio.id}-niveis-minimos`}/>
                            </Flex>}
                            <LoadingContainer linhas={8} loading={IsLoadingGraph}>
                              <Flex flexDir="column" gap=".5rem">
                                <Flex px={'2rem'} justifyContent={'space-around'}>
                                  <Text fontSize="16px" fontWeight="bold">Níveis</Text>
                                <Text fontSize="16px" fontWeight="bold">Quantidades de funções {(criterio.niveisMinimos && criterio.niveisMinimos.length > 0) ? '(desejáveis)' : ''} atribuídas para cada nível do cargo</Text>
                                </Flex>
                                <CriterioBarChart data={criterio.niveis} id={criterio.id}/>
                              </Flex>
                            </LoadingContainer>
                          </AccordionPanel>
                        </>
                      )}
                    </AccordionItem>
                  </Accordion>
                </WhiteContainer>
              )
            })}
          </Flex>
        </LoadingContainer>
      </Body>
    </Flex>
  )
}
